import {Usuario} from '../usuario/usuario.model';
import {TemplateSalvamentoModel} from '../template/template-salvamento-model';
import {FluxoSelect} from '../fluxo/fluxo-select-model';
import {DisparoAutomaticoVariavelModel} from './disparo-automatico-variavel.model';
import { DisparoInfos } from './disparo-infos.model';
import { Setor } from '../setor/setor.model';
import type { ProgramacaoDisparoModel } from './programacao-disparo.model';
import type { BlocoEmail } from '../email/modelo-email.model';
import { DisparoIntegracaoModel } from './disparo-integracao.model';

export class DisparoAutomaticoModel {
  id?: number;
  programacaoId?: number;
  ehProgramacaoRecorrente?: boolean;
  replicar?: boolean;
  programacao?: ProgramacaoDisparoModel;
  tipoProgramacao?: string;
  quantidadeEnvios?: number;
  quantidadeErros?: number;
  investimentoAcumulado?: number;
  tituloDisparo?: string;
  template?: TemplateSalvamentoModel;
  assuntoEmail?: string;
  emailRemetente?: string;
  remetenteSms?: string;
  corpoHtmlEmail?: string;
  componentesEmail: (BlocoEmail & { ordem: number })[] = [];
  fluxo?: FluxoSelect;
  etapa?: { id?: number; titulo?: string; descricao?: string };
  origemContatos?: 'EXCEL' | 'BASE_DINAMICA';
  plataformaBaseDinamicaId?: number;
  setorVinculoBaseId?: number;
  extensaoArquivo?: string;
  nomeArquivo?: string;
  tipoDisparo?: string;
  dataAgendamento?: Date;
  horaAgendamento?: string;
  quantidadeContatos?: number;
  quantidadeContatosValidos = 0;
  status?: string;
  dataEnvio?: Date;
  usuarioEnvio?: Usuario;
  uuid?: string;
  listaContatos: any;
  variaveis: DisparoAutomaticoVariavelModel[] = [];
  infos?: DisparoInfos;
  setor?: Setor;
  custoDisparo?: number;
  moedaCusto: 'BRL' | 'USD' | 'EUR' = 'USD';
  investimento?: number;
  integracao?: DisparoIntegracaoModel;
  possuiIntegracao?: boolean;
  possuiFalhaIntegracao?: boolean;
  colunasComplementares?: { id?: number; nome: string; valores?: { disparoContatoId: number; valor: string }[] }[];
  atualizadoAgora?: boolean;
}
